import { FormDataUSInternationalPersonInformation } from ".";
import { getUsPersonFormEmptyValues } from "../FormPartialUsPersonInfo/emptyValues";

export const emptyValues: FormDataUSInternationalPersonInformation = {
  usPerson: getUsPersonFormEmptyValues()
};
